import { useMutation } from "react-query";

import api from "../../../api";

export const updatePasswordService = async ({ passwordData }) => {
  const { data } = await api.post("/auth/password/change", {
    ...passwordData,
  });
  return data;
};

export const useUpdatePasswordQuery = ({ onSuccess }) => {
  const [mutate, { status, error }] = useMutation(updatePasswordService, {
    onSuccess,
  });

  return {
    mutate,
    status,
    error,
  };
};
